import { defineComponent as _defineComponent } from 'vue'
import { User } from "@/CodegenTypes";
import { mutations, queries } from "@/apollo";
import { clone } from "lodash";
import { errorMutationNotification } from "@/utils";
import { computed, onMounted, ref, watch } from "vue";
import { apolloClient } from "@/apollo";
import { addSuccessToast } from "@/vue-service";
import { useTranslation } from "@/store/translation";

export default /*#__PURE__*/_defineComponent({
  __name: 'TtIntakeSettingFormModal',
  props: {
    user: null,
    value: { type: Boolean }
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as { user: User, value: boolean };



const form = ref(getDefaultForm());

const canIntake = computed(() => {
  const isMember = props.user.roleName === "member";
  return !isMember && props.user.ddCanIntake && props.user.ddIntake;
})


const { $t } = useTranslation();



onMounted(() => {
  resetForm()
})

function toggleModal(val: boolean) {
  emit("input", val);
}

function getDefaultForm() {
  return clone({
    ttIntakeD1: props.user.ttIntakeD1,
    ttIntakeD2: props.user.ttIntakeD2,
    ttIntakeD3: props.user.ttIntakeD3,
    ttIntakeD4: props.user.ttIntakeD4,
  });
}
watch(() => (props.user), (newVal) => {
  resetForm()
});

function resetForm() {
  form.value = getDefaultForm();
}

async function handleSubmit() {
  try {
    const result = await apolloClient.mutate({
      mutation: mutations.updateOwnTtIntake,
      variables: {
        payload: {
          ttIntakeD1: form.value.ttIntakeD1,
          ttIntakeD2: form.value.ttIntakeD2,
          ttIntakeD3: form.value.ttIntakeD3,
          ttIntakeD4: form.value.ttIntakeD4,
        },
      },
      refetchQueries: [
        {
          query: queries.me,
        },
      ],
    });
    addSuccessToast("Intake setting updated.");
    toggleModal(false);
  } catch (err) {
    errorMutationNotification(err);
  }

}

return { __sfc: true,props, form, canIntake, emit, $t, toggleModal, getDefaultForm, resetForm, handleSubmit }
}

})